// Domain
const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.genericComponents.dropCancel.modal.footer.';

const CANCEL_BUTTON = `${DOMAIN}cancelButton`,
  CONTINUE_BUTTON = `${DOMAIN}continueButton`;

export { CANCEL_BUTTON, CONTINUE_BUTTON };
